import { Tracking } from './tracking/tracking';

new Tracking().init();
